import { dateSchema, requiredErrorMessage } from '@common/schema';
import { TASK_MAX_RECORDED_MINUTES } from '@common/types/constants';
import dayjs from 'dayjs';
import * as yup from 'yup';

export const addOutreachAttemptSchema = yup.object().shape({
  attempt_date: dateSchema.required(requiredErrorMessage),
  new_latest_date: dateSchema
    .required(requiredErrorMessage)
    .test(
      'within-7-days-of-attempt-date',
      'Follow-up must occur within 7 days of the attempt date',
      (value, context) => {
        const parent = context.parent;

        if (!value || !parent.attempt_date) return true;

        const attemptDate = dayjs(parent.attempt_date).startOf('day');
        const newLatestDate = dayjs(value).startOf('day');
        const maxAllowedDate = attemptDate.add(7, 'day');

        return (
          newLatestDate.isAfter(attemptDate) &&
          (newLatestDate.isSame(maxAllowedDate) ||
            newLatestDate.isBefore(maxAllowedDate))
        );
      },
    ),
  notes: yup.string().required(requiredErrorMessage),
  outreach_method: yup.string().required(requiredErrorMessage),
  notable_call: yup.boolean(),
  outreach_disposition: yup.string().required(requiredErrorMessage),
  recorded_minutes: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value,
    )
    .integer('Minutes must be a whole integer')
    .max(
      TASK_MAX_RECORDED_MINUTES,
      `Minutes must be smaller or equal to ${TASK_MAX_RECORDED_MINUTES}`,
    )
    .min(0, 'Minutes must be greater or equal to 0')
    .required(requiredErrorMessage),
});
